import { useAuth } from "@clerk/clerk-react";
import { useEffect, useRef } from "react";

import { useCartStore } from "../store/cart-store";

/**
 * Clears persisted carts when the signed-in Clerk user changes so carts do not leak across accounts
 * (see **`clearAllCarts`** on the cart store).
 */
export function CartAuthSync() {
  const { isLoaded, userId } = useAuth();
  const prevUserId = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (!isLoaded) return;
    const current = userId ?? null;
    if (prevUserId.current === undefined) {
      prevUserId.current = current;
      return;
    }
    if (prevUserId.current !== current) {
      useCartStore.getState().clearAllCarts();
      prevUserId.current = current;
    }
  }, [isLoaded, userId]);

  return null;
}
